// Register programme G6 (owner decision, 5 Oct 2026): one status per supplier across the contractor
// and supplier registers. Evidence gaps come from the same rules procurement eligibility uses.
export const supplierStatuses = ['Approved', 'Evidence expired or missing', 'Not approved', 'Not a contractor'];
export function deriveSupplierStatus(input) {
    if (input.contractorStatus === null)
        return input.supplierStatus === 'Suspended' || input.supplierStatus === 'Archived' ? 'Not approved' : 'Not a contractor';
    if (input.contractorStatus !== 'Approved' || input.supplierStatus === 'Suspended' || input.supplierStatus === 'Archived' || input.approvedServices === 0)
        return 'Not approved';
    return input.evidenceGaps.length ? 'Evidence expired or missing' : 'Approved';
}
//# sourceMappingURL=supplier-status.js.map